<template>
  <vxe-modal
    :title="modalPassTitle"
    v-model="modalShow"
    :height="modalPassHeight"
    class="ie-height"
    position="center"
    show-footer
    transfer
    :width="modalPassWidth"
    :esc-closable="closeShow"
    @close="handlePassCancel"
  >
    <slot></slot>
    <template slot="">
      <a-form-model :model="passform" :rules="rules" ref="modPassword">
        <a-row :gutter="24" v-show="pointTitle">
          <a-col :span="24">
            <font color="red"
              >您为首次登录、密码已通过上级管理用户进行了重置或超过三个月未修改，请更换登录密码。更换密码时，三次之内所用密码不可重复。</font
            >
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item
              label="当前密码"
              prop="oldPassword"
              :labelCol="{ span: 4, offset: 0 }"
              :wrapperCol="{ span: 20, offset: 0 }"
            >
              <a-input-password
                v-model="passform.oldPassword"
                placeholder="请输入当前密码"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label=" 新设密码"
              prop="password"
              :labelCol="{ span: 4, offset: 0 }"
              :wrapperCol="{ span: 20, offset: 0 }"
            >
              <a-input-password
                v-model="passform.password"
                placeholder="请输入密码长度8位以上数字、字母和特殊符号组合（特殊字符请从“#、%、*、-、_ 、!、@、$、&”中选取）"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item
              label="确认密码"
              prop="password2"
              :labelCol="{ span: 4, offset: 0 }"
              :wrapperCol="{ span: 20, offset: 0 }"
            >
              <a-input-password
                v-model="passform.password2"
                placeholder="请输入确认密码"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </template>
    <template slot="footer">
      <a-button type="primary" @click="handlePassOk" :loading="passloading">
        {{ okText }}
      </a-button>
      <a href="javascript:"></a>
    </template>
  </vxe-modal>
</template>

<script>
let oldpass = "";
let pass = "";
// 密码设置规则
const passSuffix = (rule, value, callback) => {
  if (
    !/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[#\-%_!@$&*])[\da-zA-Z#\-%_!@$&*]{8,}$/.test(
      value
    )
  ) {
    callback(
      new Error(
        "密码长度8位以上数字、字母和特殊符号组合（特殊字符请从“#、%、*、-、_ 、!、@、$、&”中选取）"
      )
    );
  } else if (oldpass === value) {
    callback(new Error("新设密码不能和原来密码相同！"));
  } else {
    pass = value;
    callback();
  }
};

//密码确认校验
const validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入新设密码"));
  } else if (value !== pass) {
    callback(new Error("两次输入密码不一致!"));
  } else {
    callback();
  }
};
const setOldPassword = (rule, value, callback) => {
  oldpass = value;
  callback();
};
//密码确认校验
const validateOldPass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请再次输入新设密码"));
  } else if (value !== pass) {
    callback(new Error("两次输入密码不一致!"));
  } else {
    callback();
  }
};

export default {
  // name: "UserHeader",
  data() {
    return {
      passform: {},
      rules: {
        oldPassword: [
          { required: true, message: "请输入当前密码", trigger: "blur" },
          { validator: setOldPassword, trigger: ["blur"] }
        ],
        password: [
          { required: true, message: "请输入新的密码", trigger: "change" },
          {
            validator: passSuffix,
            trigger: "blur"
          }
        ],
        password2: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { validator: validatePass2, trigger: ["change"] }
        ]
      },
      closeShow: false,
      // 模态窗口最大、最小化时改变窗口的大小
      className: "modPassword"
    };
  },
  props: {
    formVal: {
      type: Object,
      default: {}
    },
    modalShow: {
      type: Boolean,
      default: false
    },

    pointTitle: {
      type: String,
      default: ""
    },
    modalPassTitle: {
      type: String,
      default: "修改密码"
    },

    modalPassHeight: {
      type: String,
      default: "auto"
    },
    okText: {
      type: String,
      default: "确定"
    },
    passloading: {
      type: Boolean,
      default: false
    },
    modalPassWidth: {
      type: Number,
      default: 520
    }
  },
  mounted() {
    this.passform = this.formVal;
  },
  watch: {
    formVal: {
      handler: function(val) {
        // 此处注意，handler函数不能为箭头函数，this会取上下文，而不是组件里的this,此外，深度监听，必须为handler函数名，否则会无效果
        this.passform = this.formVal;
        //可以做些相应的处理
      },
      deep: true
    }
  },
  methods: {
    handlePassCancel() {
      this.$emit("handlePassCancel", this.$refs.modPassword);
    },
    handlePassCanceled() {
      this.handlePassCancel();
      //return (this.$slots as any).default[0].componentInstance;
    },
    handlePassOk(e) {
      this.$refs.modPassword.validate((error, values) => {});
      this.$emit("handlePassOk", this.$refs.modPassword);
    }
  }
};
</script>

<style lang="less" scoped>
.revert {
  /deep/ .vxe-modal--box {
    max-height: 80% !important;
  }
}
.max {
  /deep/ .vxe-modal--box {
    max-height: 100% !important;
  }
}
/deep/ .vxe-modal--content {
  overflow: hidden !important;
  overflow-y: auto !important;
}
/deep/ .vxe-modal--footer {
  .ant-btn {
    margin-right: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModPassword.vue